import React from "react";
import { Component } from "react";
import TasksCalendar from "../../windows/Desk/Eagleviews/tasksCalendar";
import Modal from "../Modal";

export default class AvailabilityTimeInput extends Component {
    state = {

        serviceName:
            { name: 'Service Name' },
        staffName:
            { name: this.props.user?.info?.fullname },
        timeChart: "9:00",
        morning: ['9:00 am', '9:15 am', '9:30 am', '9:45 am', '10:00 am', '10:15 am', '10:30 am', '10:45 am', '11:00 am', '11:15 am', '11:30 am', '11:45 am'],
        afternoon: ['12:00 pm', '12:15 pm', '12:30 pm', '12:45 pm', '1:00 pm', '1:15 pm', '1:30 pm', '1:45 pm', '2:00 pm', '2:15 pm', '2:30 pm', '2:45 pm', '3:00 pm', '3:15 pm', '3:30 pm', '3:45 pm'],
        evening: ['4:00 pm', '4:15 pm', '4:30 pm', '4:45 pm', '5:00 pm', '5:15 pm', '5:30 pm'],
        // calendarDay:''
    }

    timezoneModal = () => {
        this.setTimezoneModal.showModal();
    }

    timeModal = () => {
        this.setTimeModal.showModal();
    }

    calendarModal = () => {
        this.setCalendarModal.showModal();
    }
    changeTimeChart = (item) => {
        this.setState({ timeChart: item[0] }, () => {
            this.setTimeModal.hideModal()
        })
    }
    // setDataCalendarDay = (key, value) => {
    //     this.setState({ [key]: value }, () => {
    //         console.log('this key calendaaaaaaaaaaar', this.state.calendarDay)
    //     })
    // }
    render() {
        return (

            <div style={{ backgroundColor: '#f3f3f3' }}>
                {/* <Monitor title='You have some notifications' button='show notifications' user={this.props.user} lastStage={this.props.stage > 0 ? true : false} showNotification={true} showNotifications={() => this.showNotifications()} /> */}
                <div className="w-100 h-100 scroll-no-scrollbar p-1" style={{ backgroundColor: '#f3f3f3' }}
                    timeModal={this.timeModal}>
                    {/* <div > */}
                    {console.log('booooking 2222-0000-111-00----000', this.props.data)}
                    <div className='gridView' style={{}}>

                        {/* service box */}
                        {/* <div className="flexcc"> */}
                        {/* <div className="box flexcc" style={{}}>
                            <img src="/assets/icons/service.svg" style={{ opacity: '50%', height: '30px' }} />
                            <p className="box-text">{this.state.serviceName.name}</p>
                        </div> */}

                        {/* staff box */}
                        {/* <div className="box flexcc" style={{}}>
                            <img src="/assets/icons/person.svg" style={{ opacity: '50%', height: '30px' }} />
                            <p className="box-text">ali</p>
                        </div> */}

                        {/* calendar box */}
                        {/* <div className="box flexcb w-100" style={{}}>
                            <div className="flexcc img">
                                <img src="/assets/icons/calendar.svg" style={{ opacity: '50%', height: '30px' }} />
                            </div>
                            <p className="box-text" onClick={() => this.calendarModal()}>'Calendar'</p>
                        </div> */}

                        {/* timezone */}
                        {/* <div className="box flexcc" style={{}}>
                            <img src="/assets/icons/timezone.svg" style={{ opacity: '50%', height: '30px' }} />
                            <p className="box-text" onClick={() => this.timezoneModal()}>' Timezone '</p>
                        </div> */}

                        {/* time chart */}
                        <div className="box flexcc w-100" style={{}}>
                            <div className="flexcc img">
                                <img src="/assets/icons/time-chart.svg" style={{ opacity: '50%', height: '30px' }} />
                            </div>
                            <p className="box-text" onClick={() => this.timeModal()}>{this.state.timeChart}</p>
                        </div>

                        {/* book appointment */}
                        {/* <div className="box flexcc" style={{ backgroundColor: '#6aafe3' }}> */}
                        {/* <img src="/assets/icons/time-chart.svg" style={{ opacity: '50%', height: '30px' }} /> */}
                        {/* <p className="flexcc text-small" style={{ color: 'rgb(255, 255, 255)' }}>Book Appointment</p> */}
                        {/* </div> */}

                    </div>



                    {/* </div> */}


                    <Modal className="" maxWidth={300} ref={(timezoneModal) => this.setTimezoneModal = timezoneModal}>


                        <div className="d-flex w-100 h-100 window-content-radius scroll-no-scrollbar" style={{ position: 'relative' }} >
                            <div className="set-time-modal w-100 p-3" style={{ overflow: 'auto' }}>
                                <p className="text-smaller pb-3" style={{ color: 'rgb(136, 136, 136)' }}>Timezone</p>

                            </div>
                        </div>
                    </Modal>



                    <Modal className="" maxWidth={300} ref={(timeModal) => this.setTimeModal = timeModal}>


                        {console.log('item', this.props.data)}
                        <div className="d-flex w-100 h-100 window-content-radius scroll-no-scrollbar" style={{ position: 'relative' }} >
                            <div className="set-time-modal w-100 p-3" style={{ overflow: 'auto' }}>
                                <p className="text-smaller pb-3" style={{ color: 'rgb(136, 136, 136)' }}>Friday</p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Friday) && this.props.data?.Friday?.map((item, index) => {
                                        return (
                                            // <div>
                                            // {console.log('==item==', item)}
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div> 
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Monday</p>
                                <div className='grid-view-time' style={{}}>
                                    {/* {console.log('=>>=kdjalhcgazh=>>', this.props.data)} */}
                                    {Array.isArray(this.props.data?.Monday) && this.props.data?.Monday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div> 
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Saturday</p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Saturday) && this.props.data?.Saturday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div>
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Sunday</p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Sunday) && this.props.data?.Sunday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div>
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Thursday</p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Thursday) && this.props.data?.Thursday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div>
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Tuesday</p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Tuesday) && this.props.data?.Tuesday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div>
                                        )
                                    })}
                                </div>
                                <p className="text-smaller pb-3 pt-4" style={{ color: 'rgb(136, 136, 136)' }}>Wednesday
                                </p>
                                <div className='grid-view-time' style={{}}>
                                    {Array.isArray(this.props.data?.Wednesday) && this.props.data?.Wednesday?.map((item, index) => {
                                        return (
                                            // <div>
                                            <button onClick={() => this.changeTimeChart(item)} className="time-button p-1">{item[0]}</button>
                                            // </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Modal>





                    <Modal className="" maxWidth={300} ref={(calendarModal) => this.setCalendarModal = calendarModal}>


                        <div className="d-flex w-100 h-100 window-content-radius scroll-no-scrollbar" style={{ position: 'relative' }} >
                            <div className="set-time-modal w-100 p-3" style={{ overflow: 'auto' }}>
                                <div className='calendar-part'>
                                    <div className='monthly-calendar'>
                                        <TasksCalendar />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div >
            </div>
        );
    }
}

